import React from "react";
import HomePage from "./components/HomePage";

export default function App() {
  return (
    <>
      <HomePage />
    </>
  );
}
